import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import FerryService from "../../services/ferry.service";

// **Async Thunks**
export const addFerry = createAsyncThunk(
  "ferry/addFerry",
  async (item, thunkAPI) => {
    try {
      const response = await FerryService.addferry(item);
      return response.data; // Return actual data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getFerryList = createAsyncThunk(
  "ferry/getFerryList",
  async (item, thunkApi) => {
    try {
      const response = await FerryService.getferry(item);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const editFerry = createAsyncThunk(
  "ferry/editFerry",
  async (item, thunkAPI) => {
    try {
      const response = await FerryService.editferry(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteFerry = createAsyncThunk(
  "ferry/deleteFerry",
  async (id, thunkAPI) => {
    try {
      await FerryService.deleteferry(id);
      return id; // Return only the ID to remove it from state
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// **Initial State**
const initialState = {
  loading: false,
  error: "",
  ferries: [],
};

// **Slice**
const ferrySlice = createSlice({
  name: "ferry",
  initialState,
  extraReducers: (builder) => {
    builder
      // **Handle Get Ferry List**
      .addCase(getFerryList.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getFerryList.fulfilled, (state, action) => {
        state.loading = false;
        state.ferries = action.payload;
      })
      .addCase(getFerryList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Add Ferry**
      .addCase(addFerry.pending, (state) => {
        state.loading = true;
      })
      .addCase(addFerry.fulfilled, (state, action) => {
        state.loading = false;
        state.ferries.push(action.payload);
      })
      .addCase(addFerry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Edit Ferry**
      .addCase(editFerry.pending, (state) => {
        state.loading = true;
      })
      .addCase(editFerry.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.ferries.findIndex((f) => f.id === action.payload.id);
        if (index !== -1) {
          state.ferries[index] = action.payload;
        }
      })
      .addCase(editFerry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Delete Ferry**
      .addCase(deleteFerry.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteFerry.fulfilled, (state, action) => {
        state.loading = false;
        state.ferries = state.ferries.filter((f) => f.id !== action.payload);
      })
      .addCase(deleteFerry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// **Export Reducer**
export default ferrySlice.reducer;
